module.exports = __webpack_public_path__ + "static/sobba-8c1813939957535f73bcaa9757cb3fef.jpg";